import Button from "components/Button";
import { EditIcon } from "components/Icons/Edit";

import { useClientTranslation } from "hooks/useClientTranslation";

import { useStyles } from "./styles";

type EditButtonProps = {
  onClick: () => void;
};

export const EditButton = ({ onClick }: EditButtonProps) => {
  const { classes, theme } = useStyles();
  const { t } = useClientTranslation();

  return (
    <Button
      typeVariant="link"
      leftIcon={<EditIcon fill={theme.other.primary[60]} />}
      className={classes.editButton}
      onClick={onClick}
    >
      {t("global.edit")}
    </Button>
  );
};
